<template>
    <div class="error-msg-wrap">
        <div v-if="isLoaded" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>Add Process, Folder, etc</h3>
            <input type="text" placeholder="Search" v-model="searchQ" @input="search()" />
            <select v-model="formData.toSlug">
                <option v-for="(node, i) in nodes" :key="i" :value="node.Slug">{{ node.Name }}</option>
            </select>
            <input :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'AddExistingNode',
    props: [ 'fromSlug' ],
    data() {
        return {
            disableButton: false,
            isLoaded: false,
            formData: {
                fromSlug: null,
                toSlug: null
            },
            nodes: [] as any,
            allNodes: [] as any,
            searchQ: ''
        }
    },
    async created() {
        this.formData.fromSlug = this.$props.fromSlug;

        await axios.get(`${this.$store.state.apiUrl}/api/playbook/nodes`)
            .then(resp => {
                this.nodes = resp.data;
                this.allNodes = resp.data;
                this.formData.toSlug = this.nodes[0].Slug;
            })
            .catch(e => {
                console.log(e);
            })

        this.isLoaded = true;
    },
    methods: {
        async submit() {
            if(!this.formData.fromSlug || !this.formData.toSlug) {
                return;
            }

            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/playbook/nodelink`, this.formData)
                .then(resp => {
                    this.$emit('close');
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error')
                })

            this.disableButton = false;
        },
        search() {
            if(this.searchQ.length < 3) {
                this.nodes = this.allNodes;
                this.formData.toSlug = this.nodes[0].Slug;
            } else {
                const searchQLower = this.searchQ.toLowerCase();
                this.nodes = this.allNodes.filter((node: any) => {
                    return node.Name.toLowerCase().includes(searchQLower);
                })
                if(this.nodes.length) {
                    this.formData.toSlug = this.nodes[0].Slug;
                } else {
                    this.formData.toSlug = null;
                }
            }
        }
    }
});
</script>
